<template>
	<el-popover trigger="hover">
		<table-pagination
			:data="tableData"
			:column="columnData"
			 ref="tableItem">
		</table-pagination>
		
		<el-button type="text"  slot="reference">{{tableData.length}}</el-button>
	</el-popover>
</template>

<script>
	import {day_data} from '../data.js'
	export default {
		computed:{
			tableData(){
				let data = this.row[this.column.property] ? this.row[this.column.property] : []
				return data
			},
			columnData(){
				if(this.column.property != 'workDayList'){
					return this.comonColumn.concat(this.exceptdayColumn)
				}
				return this.comonColumn
			}
		},
		props: ['row', 'column'],
		data(){
			return {
				comonColumn:[
					{
						label: "日期", 
						prop: "beginTime",
						width:220,
						render: (h, scope) => {
							return <span>{this.formatDate(scope.row)}</span>
						 }
					},{
						label:'工作时间',
						prop:'workdayType',
						width:150,
						render: (h,scope) => {
							return <span>{this.$dayjs(scope.row.beginTime).format('HH:mm')}至{this.$dayjs(scope.row.endTime).format('HH:mm')}</span>
						}
					}
				],
				exceptdayColumn:[{
					label:'备注',
					prop:'remark',
					width:200,
					render: (h,scope) => {
						return <span>{scope.row.remark || '暂无'}</span>
					}
				}]
			}
		},
		methods:{
			formatDate(row){
				//父类型 workday 工作日 exceptday 特殊日
				//子类型 8 每天 9工作日间 10节假日 week每周
				let result = ''
				if(row.workdayType == 'workday'){
					switch(row.workdaySubType){
						case '8':
							result = '每天'
						break;
						case 'week':
							result = this.formatWeeks('1,2,3,4,5,6,7');
							break;
						default:
							result = this.formatWeeks(row.workdaySubType)
					}
					return result
				}
				return this.$dayjs(row.beginTime).format('YYYY-MM-DD') + ' 至 ' + this.$dayjs(row.endTime).format('YYYY-MM-DD')
			},
			formatWeeks(key){
				let keys = key ? key.split(',') : [];
				let result =[];
				keys.map(item =>{
					if(item != 'week') {
						result.push(day_data.filter(el => el.value == item)[0].label)	
					}
				})
				return result.join(',')
			}
			
		},
		
	}
</script>

<style>
</style>
